import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled } from '@mui/material';

export const BottomBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
  height: '56px',
  backgroundColor: theme.palette.colors.primaryBackground,
  fontSize: '12px',
  fontWeight: 'bold',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  textTransform: 'uppercase',
  padding: '0 16px',

  [theme.breakpoints.up('md')]: {
    padding: '0 70px',
  },
}));

export const LeftArrowIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '24px',
  color: theme.palette.colors.onPrimaryBackground,
}));
